import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  // @ts-ignore
  constructor(@Inject(DOCUMENT) private dom) {}

  public setCanonicalURL(url?: string): void {
    const canURL = url || this.dom.URL;
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
}
